import { MessageOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { getSubdomain } from "../../utils";
import { getAuthBrandConfig } from "./authBrand";
import spaLogo from "../../assets/img/spa_logo.png";
import "./login.css";

function AuthShell({ panelTitle, panelSubtitle, children }) {
  const brandConfig = getAuthBrandConfig(getSubdomain());
  const poweredBy = (
    <div className="weiser-login-powered weiser-login-powered--footer">
      <span className="weiser-login-powered-label">Powered by</span>
      <div className="weiser-login-powered-lockup">
        <img src={spaLogo} alt="Smart People Africa" />
        <span>Smart People Africa</span>
      </div>
    </div>
  );

  return (
    <div className="weiser-login-page">
      <div className="weiser-login-shell">
        <div className="weiser-login-ambient" />
        <div className="weiser-login-orb weiser-login-orb-top" />
        <div className="weiser-login-orb weiser-login-orb-middle" />
        <div className="weiser-login-orb weiser-login-orb-bottom" />

        <div className="weiser-login-stage">
          <div className="weiser-login-grid">
            <section className="weiser-login-story" aria-label="Messaging channels">
              <div
                className={`weiser-login-brand ${
                  brandConfig.useSmartgateMark ? "weiser-login-brand--smartgate" : ""
                }`}
              >
                {brandConfig.useSmartgateMark ? (
                  <div
                    className="weiser-login-brand-mark weiser-login-brand-mark--smartgate"
                    aria-hidden="true"
                  >
                    <svg viewBox="0 0 64 64" className="weiser-smartgate-logo">
                      <defs>
                        <linearGradient id="smartgateAccent" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#ffffff" stopOpacity="0.98" />
                          <stop offset="1" stopColor="#dff6ea" stopOpacity="0.96" />
                        </linearGradient>
                      </defs>
                      <path
                        d="M20 26C20 18.82 25.82 13 33 13C40.18 13 46 18.82 46 26V47H20V26Z"
                        fill="none"
                        stroke="url(#smartgateAccent)"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M26 25.5H40"
                        stroke="url(#smartgateAccent)"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M33 18V47"
                        stroke="url(#smartgateAccent)"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <circle cx="33" cy="33" r="2.5" fill="#ffffff" />
                      <path
                        d="M15 18C18.3 13.6 24.8 10 33 10C40 10 45.9 12.6 49.5 16.7"
                        fill="none"
                        stroke="#dff6ea"
                        strokeOpacity="0.78"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="weiser-login-brand-mark">
                    <img src={brandConfig.logo} alt="" />
                  </div>
                )}
                <span>{brandConfig.name}</span>
              </div>

              <div className="weiser-login-copy">
                <h1>
                  Two channels.
                  <br />
                  One platform.
                </h1>
                <p>
                  Reach every customer on their preferred channel without juggling two
                  dashboards.
                </p>
              </div>

              <div className="weiser-channel-list">
                <div className="weiser-channel-card">
                  <div className="weiser-channel-icon weiser-channel-icon-sms">
                    <MessageOutlined />
                  </div>
                  <div className="weiser-channel-text">
                    <strong>SMS</strong>
                    <span>Universal reach. No app required.</span>
                  </div>
                  <span className="weiser-channel-pill">Active</span>
                </div>

                <div className="weiser-channel-card weiser-channel-card-wa">
                  <div className="weiser-channel-icon weiser-channel-icon-wa">
                    <WhatsAppOutlined />
                  </div>
                  <div className="weiser-channel-text">
                    <strong>
                      WhatsApp
                      <em>NEW</em>
                    </strong>
                    <span>Rich media. Two-way chat. Templates.</span>
                  </div>
                  <span className="weiser-channel-pill weiser-channel-pill-wa">Live</span>
                </div>
              </div>
            </section>

            <section className="weiser-login-panel" aria-label={panelTitle}>
              <div className="weiser-login-panel-header">
                <h2>{panelTitle}</h2>
                <p>{panelSubtitle}</p>
              </div>
              {children}
            </section>
          </div>

          {poweredBy}
        </div>
      </div>
    </div>
  );
}

export default AuthShell;
